.email-composer-form {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.reply-container {
    display: flex;
}

.reply-to-field {
    /* The 128px here matches the width of our reply/all dropdown */
    width: calc(100% - 128px);
}

.composer-fields {
    display: flex;
    flex-grow: 1;
    min-height: 0; /* For firefox */
    position: relative;
}
